import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue";
var _hoisted_1 = {
  class: "tui-contact-list-card-left"
};
var _hoisted_2 = {
  class: "tui-contact-list-card-main"
};
var _hoisted_3 = {
  class: "tui-contact-list-card-main-name"
};
var _hoisted_4 = {
  class: "tui-contact-list-card-right"
};
var _hoisted_5 = {
  key: 0,
  class: "tui-contact-list-card-right-application"
};
var _hoisted_6 = {
  key: 0,
  class: "tui-contact-list-card-right-application-text"
};
import { computed, inject, watch, ref } from '../../../../adapter-vue';
import TUIChatEngine, { TUITranslateService } from '@tencentcloud/chat-uikit-engine';
import Avatar from '../../../common/Avatar/index.vue';
import { generateAvatar, generateName, acceptFriendApplication } from '../../utils';
import { isPC } from '../../../../utils/env';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    item: {
      default: () => ({})
    },
    displayOnlineStatus: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    var props = __props;
    var userOnlineStatusMap = inject('userOnlineStatusMap');
    var isOnline = ref(false);
    var groupType = {
      [TUIChatEngine.TYPES.GRP_WORK]: 'Work',
      [TUIChatEngine.TYPES.GRP_AVCHATROOM]: 'AVChatRoom',
      [TUIChatEngine.TYPES.GRP_PUBLIC]: 'Public',
      [TUIChatEngine.TYPES.GRP_MEETING]: 'Meeting',
      [TUIChatEngine.TYPES.GRP_COMMUNITY]: 'Community'
    };
    var otherContentForSow = computed(() => {
      var _props$item, _TUIChatEngine$TYPES, _props$item2, _TUIChatEngine$TYPES2, _props$item4;
      var content = '';
      if (((_props$item = props.item) === null || _props$item === void 0 ? void 0 : _props$item.type) === (TUIChatEngine === null || TUIChatEngine === void 0 || (_TUIChatEngine$TYPES = TUIChatEngine.TYPES) === null || _TUIChatEngine$TYPES === void 0 ? void 0 : _TUIChatEngine$TYPES.SNS_APPLICATION_SENT_TO_ME) || ((_props$item2 = props.item) === null || _props$item2 === void 0 ? void 0 : _props$item2.type) === (TUIChatEngine === null || TUIChatEngine === void 0 || (_TUIChatEngine$TYPES2 = TUIChatEngine.TYPES) === null || _TUIChatEngine$TYPES2 === void 0 ? void 0 : _TUIChatEngine$TYPES2.SNS_APPLICATION_SENT_BY_ME)) {
        var _props$item3;
        content = ((_props$item3 = props.item) === null || _props$item3 === void 0 ? void 0 : _props$item3.wording) || '';
      } else if ((_props$item4 = props.item) !== null && _props$item4 !== void 0 && _props$item4.groupID) {
        var _props$item5;
        content = "ID:".concat((_props$item5 = props.item) === null || _props$item5 === void 0 ? void 0 : _props$item5.groupID);
      }
      return content;
    });
    var groupTypeForShow = computed(() => {
      var _props$item6;
      var type = '';
      if ((_props$item6 = props.item) !== null && _props$item6 !== void 0 && _props$item6.groupID) {
        var _props$item7;
        type = groupType[(_props$item7 = props.item) === null || _props$item7 === void 0 ? void 0 : _props$item7.type];
      }
      return type;
    });
    var showApplicationStatus = computed(() => {
      var _props$item8, _TUIChatEngine$TYPES3, _props$item9, _TUIChatEngine$TYPES4;
      if (((_props$item8 = props.item) === null || _props$item8 === void 0 ? void 0 : _props$item8.type) === (TUIChatEngine === null || TUIChatEngine === void 0 || (_TUIChatEngine$TYPES3 = TUIChatEngine.TYPES) === null || _TUIChatEngine$TYPES3 === void 0 ? void 0 : _TUIChatEngine$TYPES3.SNS_APPLICATION_SENT_BY_ME)) {
        return {
          style: 'text',
          label: '等待验证'
        };
      } else if (((_props$item9 = props.item) === null || _props$item9 === void 0 ? void 0 : _props$item9.type) === (TUIChatEngine === null || TUIChatEngine === void 0 || (_TUIChatEngine$TYPES4 = TUIChatEngine.TYPES) === null || _TUIChatEngine$TYPES4 === void 0 ? void 0 : _TUIChatEngine$TYPES4.SNS_APPLICATION_SENT_TO_ME)) {
        return {
          style: 'button',
          label: '同意',
          onClick: () => {
            var _props$item10;
            acceptFriendApplication((_props$item10 = props.item) === null || _props$item10 === void 0 ? void 0 : _props$item10.userID);
          }
        };
      }
      return false;
    });
    watch(() => userOnlineStatusMap === null || userOnlineStatusMap === void 0 ? void 0 : userOnlineStatusMap.value, () => {
      isOnline.value = getOnlineStatus();
    }, {
      immediate: true,
      deep: true
    });
    function getOnlineStatus() {
      var _props$item11, _userOnlineStatusMap$;
      return !!(props.displayOnlineStatus && userOnlineStatusMap !== null && userOnlineStatusMap !== void 0 && userOnlineStatusMap.value && (_props$item11 = props.item) !== null && _props$item11 !== void 0 && _props$item11.userID && ((_userOnlineStatusMap$ = userOnlineStatusMap.value) === null || _userOnlineStatusMap$ === void 0 || (_userOnlineStatusMap$ = _userOnlineStatusMap$[props.item.userID]) === null || _userOnlineStatusMap$ === void 0 ? void 0 : _userOnlineStatusMap$.statusType) === TUIChatEngine.TYPES.USER_STATUS_ONLINE);
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(['tui-contact-list-card', !_unref(isPC) && 'tui-contact-list-card-h5'])
      }, [_createElementVNode("div", _hoisted_1, [_createVNode(Avatar, {
        class: "tui-contact-list-card-left-avatar",
        useSkeletonAnimation: "",
        url: _unref(generateAvatar)(props.item)
      }, null, 8, ["url"]), props.displayOnlineStatus && props.item ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass({
          'online-status': true,
          'online-status-online': _unref(isOnline),
          'online-status-offline': !_unref(isOnline)
        })
      }, null, 2)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(_unref(generateName)(props.item)), 1)]), _createElementVNode("div", _hoisted_4, [_unref(showApplicationStatus) ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_unref(showApplicationStatus).style === 'text' ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_unref(TUITranslateService).t("TUIContact.".concat(_unref(showApplicationStatus).label))), 1)) : _unref(showApplicationStatus).style === 'button' ? (_openBlock(), _createElementBlock("button", {
        key: 1,
        class: "tui-contact-list-card-right-application-button",
        onClick: _cache[0] || (_cache[0] = _withModifiers(
        //@ts-ignore
        function () {
          return _unref(showApplicationStatus).onClick && _unref(showApplicationStatus).onClick(...arguments);
        }, ["stop"]))
      }, _toDisplayString(_unref(TUITranslateService).t("TUIContact.".concat(_unref(showApplicationStatus).label))), 1)) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])], 2);
    };
  }
});